import * as vp from 'vopay';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || '';
const learningBaseUrl = import.meta.env.VITE_LEARNING_CENTRE_BASE_URL;

const apiConfig = vp.VoPayApi(apiBaseUrl, learningBaseUrl);

export const api = apiConfig.api;

export default apiConfig;
